import React from 'react';
import PropTypes from 'prop-types';
import styles from './SelectableBlock.scss';
import { Checkbox } from 'semantic-ui-react';

const SelectableBlock = ({
  cardBorder,
  checked,
  checkbox,
  children,
  className,
  color,
  content,
  disabled,
  name,
  onChange,
  radio,
  style,
  value
}) =>
  <div
    className={[
      className,
      checked ? styles.selectableBlockSelected : styles.selectableBlock,
      (radio || checkbox) ? styles.showIndicator : '',
      disabled ? styles.selectableBlockDisabled : '',
      cardBorder ? styles.cardBorder : '',
      color && checked ? styles[color] : ''
    ].join(' ')}
    style={style}
    onClick={(e) => {
      if (!disabled) {
        onChange(e, { checked: !checked, name, value });
      }
    }}
  >
    {content || children}
    {(checkbox || radio) &&
      <span className={styles.checkbox}>
        <Checkbox
          radio={radio}
          onClick={(e, data) => {
            if (!disabled) {
              onChange(e, Object.assign(data, { checked: !checked }));
            }
          }}
          checked={checked}
          disabled={disabled}
          name={name}
          value={value}
        />
      </span>
    }
  </div>;

SelectableBlock.propTypes = {
  cardBorder: PropTypes.bool,
  checked: PropTypes.bool,
  checkbox: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf(['grey']),
  content: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  radio: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.any
};

export default SelectableBlock;



// WEBPACK FOOTER //
// ./webpack/components/Elements/SelectableBlock/SelectableBlock.js